import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { sanityClient } from "@/js/sanity/client";
import { urlForImage } from "@/js/sanity/image";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "CellarJournal",
  components: {
    BackgroundVideo: BackgroundVideo
  },
  data: function data() {
    return {
      posts: []
    };
  },
  methods: {
    urlForImage: urlForImage
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var query;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            query = "*[_type == \"post\"] | order(_createdAt desc) {\n        \"slug\": slug.current,\n        title,\n        shortTitle,\n        briefDescription,\n        mainImage\n      }";
            _context.next = 4;
            return sanityClient.fetch(query);
          case 4:
            _this.posts = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error("Error fetching posts:", _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }
};